import React from 'react';
import { connect } from 'react-redux';
import { UserStatus } from '$/core/enums';
import { AppState } from '$/store';
import { getUserStatusState } from '$/store/profile/selectors';
import './WorkflowUserSection.scss';

export type IWorkflowUserSectionProps = object;

interface IWorkflowUserSectionReduxProps extends IWorkflowUserSectionProps {
  userStatus?: UserStatus | null;
}

const statusIconMap: Record<UserStatus, string> = {
  [UserStatus.Available]: '●',
  [UserStatus.Break]: '◐',
  [UserStatus.OutOfOffice]: '✕',
  [UserStatus.Busy]: '⊝',
};

const WorkflowUserSection: React.FC<IWorkflowUserSectionReduxProps> = ({ userStatus }) => {
  if (!userStatus) return null;

  return (
    <div className="workflow-user-section">
      <span className="workflow-status-label">Your Status:</span>
      <span className={`workflow-status-icon ${userStatus.toLowerCase().replaceAll(' ', '-')}`}>
        {statusIconMap[userStatus]}
      </span>
      <span className={`workflow-status-text ${userStatus.toLowerCase().replaceAll(' ', '-')}`}>{userStatus}</span>
    </div>
  );
};

function mapStateToProps(state: AppState, ownProps: IWorkflowUserSectionProps): IWorkflowUserSectionReduxProps {
  const { userStatus } = getUserStatusState(state);
  return { ...ownProps, userStatus };
}

export default connect(mapStateToProps)(WorkflowUserSection);
